<style scoped>
  #news-wrapper {
    height: 695px;
    background-color: #f5f5f5;
  }

  #news {
    display:flex;
    flex-direction:column;
    height:465px;
    flex-wrap: wrap;
  }
  .news_link{
    /*background-color: pink;*/
  }
  .news_link:not(:first-child) {
    flex: 1 50%;
    margin-left:10px;
  }
  .news_link:first-of-type{
    height:100%;
    /*background-color:red;*/
  }

  #news-wrapper {
    height: 695px;
    background-color: #f5f5f5;
  }

  #news-tabs {
    display: flex;
    position: relative;
    justify-content: center;
  }

  .news-tab {
    font-size: 14px;
    float: left;
    display: inline-block;
    width: 90px;
    height: 35px;
    line-height:35px;
    background-color: #e5e5e5;
    z-index: 5;
    cursor: pointer;
    margin-right: 25px;
    color: #757575;
    text-align: center;
    border-radius: 4px;
  }

  .news-tab.active {
    z-index: 10;
    background: #0077db;
    color: #fff;
  }
  .index-more a{
    color: #999;
    font-size:14px;
    height:35px;
    width:135px;
    border-radius: 4px;
    line-height:35px;
    text-align: center;
    border:1px solid #ddd;
    display: block;
    margin:0 auto;
  }

  .index-more a:hover {
    color: #0077db;
    border-color: #0077db;
  }
  .title h3 {
    font-size: 24px;
    padding-top: 50px;
    letter-spacing: 3px;
    color: #5d5d5d;
    font-weight: bold;
    text-align: center;
    padding-bottom: 40px;
  }
</style>
<style>
  .news_link:first-of-type img{
    width:400px;
    height:400px;
  }
  .news_link:first-of-type .new_pic{
    height:402px;
    width:402px;
  }
  .news_link:not(:first-child) .new_pic{
    height:182px;
    width:342px;
  }
  .news_link:first-of-type h3{
    width:400px;
    height:60px;
    line-height:60px;
  }
  .news_link:not(:first-child) h3{
    width:340px;
    height:40px;
    line-height:40px;
  }
</style>

<template>
    <div id="news-wrapper">
      <div class="container" v-if="!isLoading && news.length > 0">
        <div class="title">
          <h3>资讯干货</h3>
        </div>
        <ul id="news-tabs">
          <li class="news-tab"
              v-for="item in categories"
              :title=" item.remark "
              :class="{active: isNewsTab(item.id)}"
              v-on:mouseover="setNewsTab(item.id),newsTab=item.id">
            {{ item.name }}
          </li>

        </ul>
        <div id="news" style="padding-top:30px;">
          <lh-loading v-if="articleLoading"></lh-loading>
          <lh-news
            v-else
            v-for="article in currentNews" class="news_link"
            :front_img_path="article.front_img_path"
            :title="article.title"
            :summary="article.summary"
            :tags="article.tags"
            :date="article.create_time"
            :views="article.views"
            :id="article.id">
          </lh-news>
        </div>
        <div class="index-more">
          <router-link :to="{ path: '/ArticleHome' }">查看更多</router-link>
        </div>
      </div>
    </div>
</template>

<script>
  import articleApi from '../api/article'

  export default {
    data () {
      return {
        isLoading: false,
        articleLoading: false,
        categories: [
          {
            id: 1,
            name: '创业资讯',
            href: '/articles/list',
            remark: '怎样注册新公司新公司成立后要做什么'
          },
          {
            id: 2,
            name: '财务干货',
            href: '/articles/list',
            remark: '中小型企业如何合理避税没有专业税务人员的企业怎么避税'
          },
          {
            id: 3,
            name: '法律干货',
            href: '/articles/list',
            remark: '解决法律纠纷，拟定合同的关键点'
          },
          {
            id: 4,
            name: '人事干货',
            href: '/articles/list',
            remark: '创业公司的员工激励怎么做用什么人事平台'
          },
          {
            id: 5,
            name: '工商干货',
            href: '/articles/list',
            remark: '商标被侵权了怎么办'
          },
        ],
        newsTab: 0,
        voiceBanner: 0,
        hotActive: 3,
        news: [],
        currentNews: []
      }
    },
    props: {
    },
    computed: {},
    methods: {
      chooseArticle(article) {
        this.$router.push({path: `/articles/${article.id}`})
      },
      setNewsTab (id) {
        let vm = this
        vm.newsTab = id
        if (vm.news[id]) {
          vm.currentNews = vm.news[id]
        } else {
          vm.articleLoading = true
          articleApi.getArticles(
            {category: id, pageSize: 5, page: 1},
            data => {
//              console.log(data.results)
//              debugger
//              vm.currentNews = data.results
              vm.isLoading = false
              vm.articleLoading = false
              vm.news[id] = data.results
              vm.currentNews = data.results
            }, error => {
              vm.error = error
              console.log(`[article]${error}`)
//              vm.$message({
//                type: 'error',
//                message: error
//              })
            })

        }
      },
      isNewsTab (id) {
//        console.log(index)
        return this.newsTab === id
      },
    },
    created () {
      this.isLoading = true
      let vm = this
      articleApi.getArticles(
        {category: 1, pageSize: 5, page: 1},
        data => {
          vm.currentNews = data.results
          vm.isLoading = false

          vm.news[1] = data.results
        }, error => {
          vm.error = error
          console.log('[article]' + error)
//          vm.$message({
//            type: 'error',
//            message: error
//          })
        })
    },
    mounted () {

    }
  }
</script>



// WEBPACK FOOTER //
// ArticleList.vue?7d945a20